var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.21,97.08h20v36.69h-20M130.14,76.55h36.07v55.87s3.88,22.21-16.75,22.21H119.18M82.78,74.54H34.46V154.3H77m34.77-54.86,2.92-47.79L65.79,117.09l26.44-.72.54,45,44.15-61.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricBattery);
export default __webpack_public_path__ + "static/media/ELECTRIC_BATTERY.8f39a8f181589a65cdee10cded6b54a8.svg";
export { ForwardRef as ReactComponent };